/**
 * Action types offered by the audit log's action filter, grouped by entity. Kept apart from
 * AuditLogList so the options can be checked against the translations without rendering the
 * list. Every option needs `auditLog.actionType.<TYPE>` in all locale files.
 *
 * CZNA-1607: offer exactly the actions mod-czna-users writes — an option nothing writes always
 * finds nothing, which reads as "nobody did that". Older stored actions (RECORD_*,
 * USER_PASSWORD_CHANGED) keep their translations so the list and detail still name old rows.
 * auditLogActionTypeParity.test.ts compares this list with the backend's write sites.
 */
export var ACTION_TYPE_OPTIONS = [
    {
        label: "ui-czna-users.auditLog.filter.actionType.group.users",
        options: [
            "USER_CREATED",
            "USER_UPDATED",
            "USER_ARCHIVED",
            "USER_RESTORED",
            // CZNA-1609 — irreversible, so it must be findable
            "USER_PURGED",
            "USER_PASSWORD_RESET",
            // CZNA-1607 — what a password set writes; USER_PASSWORD_CHANGED is written by nothing
            "USER_PASSWORD_SET",
            // CZNA-1594 — global and authority-type roles alike
            "USER_ROLE_ASSIGNED",
            "USER_ROLE_CHANGED",
            "USER_ROLE_REMOVED",
        ],
    },
    {
        label: "ui-czna-users.auditLog.filter.actionType.group.organizations",
        options: [
            "ORGANIZATION_CREATED",
            "ORGANIZATION_UPDATED",
            "ORGANIZATION_ARCHIVED",
            "ORGANIZATION_RESTORED",
        ],
    },
];
